// Vendor Libs
import { useDispatch, useSelector } from 'react-redux'; // Firsestorm React

import { actions } from '@dishtech-react/redux';
var _registerService = actions.registerService,
    _setParamValue = actions.setParamValue,
    _setParamValues = actions.setParamValues,
    _unregisterService = actions.unregisterService;
export var useService = function useService(serviceKey) {
  var dispatch = useDispatch();
  return {
    fetched: useSelector(function (_ref) {
      var _ref$service = _ref.service;
      _ref$service = _ref$service === void 0 ? {} : _ref$service;
      var _ref$service$serviceK = _ref$service[serviceKey];
      _ref$service$serviceK = _ref$service$serviceK === void 0 ? {} : _ref$service$serviceK;
      var fetched = _ref$service$serviceK.fetched;
      return fetched;
    }),
    fetching: useSelector(function (_ref2) {
      var _ref2$service = _ref2.service;
      _ref2$service = _ref2$service === void 0 ? {} : _ref2$service;
      var _ref2$service$service = _ref2$service[serviceKey];
      _ref2$service$service = _ref2$service$service === void 0 ? {} : _ref2$service$service;
      var fetching = _ref2$service$service.fetching;
      return fetching;
    }),
    params: useSelector(function (_ref3) {
      var _ref3$service = _ref3.service;
      _ref3$service = _ref3$service === void 0 ? {} : _ref3$service;
      var _ref3$service$service = _ref3$service[serviceKey];
      _ref3$service$service = _ref3$service$service === void 0 ? {} : _ref3$service$service;
      var params = _ref3$service$service.params;
      return params;
    }),
    registerService: function registerService() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return dispatch(_registerService.apply(void 0, [serviceKey].concat(args)));
    },
    serviceContent: useSelector(function (_ref4) {
      var _ref4$service = _ref4.service;
      _ref4$service = _ref4$service === void 0 ? {} : _ref4$service;
      var _ref4$service$service = _ref4$service[serviceKey];
      _ref4$service$service = _ref4$service$service === void 0 ? {} : _ref4$service$service;
      var response = _ref4$service$service.response;
      return response;
    }) || {},
    setParamValue: function setParamValue() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return dispatch(_setParamValue.apply(void 0, [serviceKey].concat(args)));
    },
    setParamValues: function setParamValues() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return dispatch(_setParamValues.apply(void 0, [serviceKey].concat(args)));
    },
    unregisterService: function unregisterService() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return dispatch(_unregisterService.apply(void 0, [serviceKey].concat(args)));
    }
  };
};